import _toConsumableArray from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { getResponsiveProp, rem, responsive } from '../helpers';
export function responsiveFont(fontKey, props) {
  var size = props.size,
      theme = props.theme,
      weight = props.weight;
  var _theme$sanity$fonts$f = theme.sanity.fonts[fontKey],
      family = _theme$sanity$fonts$f.family,
      sizes = _theme$sanity$fonts$f.sizes,
      weights = _theme$sanity$fonts$f.weights;
  var fontWeight = weight && weights[weight] || weights['regular']; // @todo: make this configurable

  var defaultSize = sizes[2];
  var ret = [{
    position: 'relative',
    fontFamily: family,
    fontWeight: fontWeight,
    padding: '1px 0',
    margin: 0,
    // '&:before': {
    //   content: '',
    //   display: 'block',
    //   height: 0,
    // },
    // '&:after': {
    //   content: '',
    //   display: 'block',
    //   height: 0,
    // },
    '&&:not([hidden])': {
      display: 'block'
    }
  }].concat(_toConsumableArray(responsive(theme.sanity.media, getResponsiveProp(size).map(function (sizeIndex) {
    return fontSize(sizes[sizeIndex] || defaultSize);
  }))));
  return ret;
}
export function fontSize(size) {
  var negHeight = size.ascenderHeight + size.descenderHeight;
  var capHeight = size.lineHeight - negHeight;
  return {
    fontSize: rem(size.fontSize),
    lineHeight: rem(size.lineHeight),
    letterSpacing: rem(size.letterSpacing),
    transform: "translateY(".concat(rem(size.descenderHeight), ")"),
    '&:before': {
      marginTop: "calc(".concat(rem(0 - negHeight), " - 1px)")
    },
    '&:after': {
      marginBottom: '-1px'
    },
    '& [data-sanity-icon]': {
      fontSize: rem(size.iconSize),
      margin: rem((capHeight - size.iconSize) / 2)
    }
  };
}